import { Button, DialogActions, DialogTitle, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import { TURN_STYLES } from '@/styles/theme';

export const DialogTitleStyled = styled(DialogTitle)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const DialogDescription = styled('p')(({ theme }) => ({
  marginTop: 0,
  marginRight: 0,
  marginBottom: '16px',
  marginLeft: 0,

  fontSize: '14px',
  lineHeight: '20px',
  color: theme.palette.mode === 'dark' ? TURN_STYLES.darkSecondaryColor : TURN_STYLES.primaryColor,
}));

export const FieldWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',

  width: '100%',
});

export const FieldLabel = styled('span')(({ theme }) => ({
  fontSize: '13px',
  fontWeight: 600,
  lineHeight: '18px',
  color: theme.palette.mode === 'dark' ? TURN_STYLES.darkSecondaryColor : TURN_STYLES.neutralDark,
}));

export const RequiredMark = styled('span')({
  marginLeft: '2px',

  color: TURN_STYLES.errorDark,
});

export const ReasonField = styled(TextField)({
  width: '100%',
  maxWidth: '100%',

  '& .MuiOutlinedInput-root': {
    width: '100%',
    maxWidth: '100%',
    height: 'auto',
    maxHeight: 'none',
  },

  '& .MuiOutlinedInput-root.MuiInputBase-multiline': {
    width: '100%',
    maxWidth: '100%',
    height: 'auto',
    maxHeight: 'none',
  },
});

export const DialogActionsStyled = styled(DialogActions)({
  paddingTop: '16px',
  paddingRight: '24px',
  paddingBottom: '16px',
  paddingLeft: '24px',
  gap: '8px',

  '& .MuiButton-root': {
    width: 'auto',
    minWidth: '64px',
  },

  '& .MuiButton-root:not(.MuiButton-contained)': {
    backgroundColor: 'transparent',
    color: TURN_STYLES.secondaryButtonColor,
    fontWeight: 'bold',
    boxShadow: 'none',
  },
});

export const DialogCancelButton = styled(Button)({
  fontWeight: 'bold',
  color: TURN_STYLES.secondaryButtonColor,
});

export const ConfirmButton = styled(Button)({
  backgroundColor: TURN_STYLES.primaryAccentColor,
  color: '#fff',
  fontWeight: 600,
  boxShadow: 'none',

  '&:hover': {
    backgroundColor: TURN_STYLES.violetDark,
    color: '#fff',
    boxShadow: 'none',
  },
});
